<template>
    <div>

        <template v-if="phone">

            <div class="pa-4">



                <div class="text-center my-3 py-3">
                    Номер телефона
                    <div class="d-flex justify-center">
                        {{phone}}
                    </div>
                </div>



            </div>


            <sg-items-block>
                <v-list-item @click="editPhone">
                    <v-list-item-icon>
                        <v-icon>mdi-pen</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="d-block">
                        <v-list-item-title>Сменить</v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

            </sg-items-block>

        </template>

        <template v-else>

            <div class="py-4">
                <div class="text-center my-5 py-5">
                    Номер телефона не указан
                </div>

                <div class="text-body-2 grey--text px-5">
                    <div>Введенный номер сотового телефона позволяет использовать дополнительные сервисы:</div>

                    <div class="pt-2">Вход в Личный кабинет (в качестве логина можно указать номер сотового телефона);
                    </div>

                    <div class="pt-2">Оперативная смена пароля входа в Личный кабинет с сотового телефона. Для этого
                        необходимо отправить СМС-сообщение с текстом "password" (без кавычек) на номер +7-903-767-20-24.
                        В ответ будет выслано СМС-сообщение с новым паролем</div>

                    <div class="pt-2">Получение оповещений о необходимости внесения показаний счетчиков.</div>
                </div>

                <!-- 
                <div class="d-flex justify-center mt-5">
                    <v-btn @click="setPhone" color="primary" depressed>Указать</v-btn>
                </div> -->

            </div>

                    <v-footer app>
            <v-btn @click="setPhone" color="primary" block depressed>Указать</v-btn>
        </v-footer>


        </template>


        <sg-nav-back-btn class="mt-3" />

    </div>
</template>

<script>


    export default {


        computed: {

            userInfo() {
                return this.$store.state.settings.userInfo
            },

            phone() {
                return this.userInfo && this.userInfo.contacts.phone
            }
        },
        methods: {
            setPhone() {

                this.$router.push({
                    name: 'wv-settings-phone-edit'
                })

            },
            editPhone() {
                this.$router.push({
                    name: 'wv-settings-phone-edit'
                })
            }
        }
    }
</script>

<style>

</style>